import { render, staticRenderFns } from "./DfCoach.vue?vue&type=template&id=52e16522&"
import script from "./DfCoach.vue?vue&type=script&lang=js&"
export * from "./DfCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports